export default __webpack_public_path__ + "static/media/home.d5d5cde6.svg";